import React from "react";
import { CloseOutlined, Save } from "@mui/icons-material";
import useMode from "hooks/useMode";
import { TextCus } from "components/TextCus";
import { fontSize } from "theme";
import {
  Grid,
  Box,
  Fade,
  IconButton,
  Modal,
} from "@mui/material";
import { InputOutLine } from "components/InputCus";
import { ButtonCus } from "components/ButtonCus";

interface IModalProfile {
  open: boolean;
  onClose: () => void;
}


const ModalSettings = ({ open, onClose }: IModalProfile) => {
  const mode = useMode();

  return (
    <Modal
      keepMounted
      open={open}
      closeAfterTransition
      sx={{
        backgroundColor: "#000000087",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClose={onClose}
      aria-labelledby="keep-mounted-modal-title"
      aria-describedby="keep-mounted-modal-description"
    >
      <Fade in={open} timeout={500}>
        <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-center"}
          flexDirection={"column"}
          position={"relative"}
          padding={"20px"}
          bgcolor={mode.secondary}
          sx={{
            maxWidth: "800px",
            maxHeight: "80vh",
            width: {
              xs: "90vw",
            },
          }}
          height={"auto"}
          maxHeight={"764px"}
          borderRadius={"12px"}
        >
          <IconButton
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
              ":hover": { bgcolor: "transparent" },
            }}
          >
            <CloseOutlined />
          </IconButton>
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"start"}
            width={"100%"}
          >
            <TextCus
              fontSize={fontSize.md}
              color={mode.primary}
              fontWeight={"600"}
            >
              Setting
            </TextCus>
          </Box>
          <Box component={"form"} onSubmit={() => { }}>
            <Grid container spacing={4} rowSpacing={2} sx={{ mt: 1 }}>
              {/* Product Name */}
              <Grid size={{ xs: 12, md: 12 }} >
                <InputOutLine
                  isShowLabel
                  height="40px"
                  type="number"
                  min={1}
                  max={2}
                  fullWidth
                  label="データ受信日を設定する" />
              </Grid>

            </Grid>
            <Box
              mt={"10px"}
              display={"flex"}
              justifyContent={"center"}
              width={"100%"}
              gap={"20px"}
            >
              <ButtonCus
                type="submit"
                startIcon={<Save />}
                sx={{ minWidth: 120 }}
                title="Save"
              />
            </Box>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default ModalSettings;
